<!-- 用水户型列表 -->
<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('用户编码')">
              <a-input :placeholder="$t('请输入用户编码')" v-model="queryParam.htCode"></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('户型名称')">
              <a-input :placeholder="$t('请输入户型名称')" v-model="queryParam.htName"></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">{{ $t('查询') }}</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{ $t('重置') }}</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" type="primary" icon="plus">{{ $t('新增') }}</a-button>
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel"><a-icon type="delete"/>{{ $t('删除') }}</a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px"> {{ $t('批量操作') }} <a-icon type="down" /></a-button>
      </a-dropdown>
    </div>
    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;" v-if="selectedRowKeys.length > 0">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> {{ $t('已选择 {count} 项', { count: selectedRowKeys.length }) }}
        <a style="margin-left: 24px" @click="onClearSelected">{{ $t('清空') }}</a>
      </div>
      <a-table
        ref="table"
        size="middle"
        :scroll="{x:true}"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        class="j-table-force-nowrap"
        @change="handleTableChange">

        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">{{ $t('编辑') }}</a>
          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">{{ $t('更多') }} <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a @click="handleDetail(record)">{{ $t('详情') }}</a>
              </a-menu-item>
              <a-menu-item>
                <a-popconfirm :title="$t('确定删除吗?')" @confirm="() => handleDelete(record.id)">
                  <a>{{ $t('删除') }}</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>
      </a-table>
    </div>
    <meter-household-modal ref="modalForm" @ok="modalFormOk"></meter-household-modal>
  </a-card>
</template>

<script>
  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import MeterHouseholdModal from './modules/MeterHouseholdModal'

  export default {
    name: 'MeterHouseholdList',
    mixins:[JeecgListMixin, mixinDevice],
    components: {
      MeterHouseholdModal
    },
    data () {
      return {
        description: 'meter_household管理页面',
        url: {
          list: "/jeecg-charge/meter/meterHousehold/list",
          delete: "/jeecg-charge/meter/meterHousehold/delete",
          deleteBatch: "/jeecg-charge/meter/meterHousehold/deleteBatch",
          exportXlsUrl: "/jeecg-charge/meter/meterHousehold/exportXls",
          importExcelUrl: "jeecg-charge/meter/meterHousehold/importExcel", 
        },
        dictOptions:{},
      }
    },
    created() {
    },
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
      // i18n：表头使用 computed 以响应语言切换
      columns() {
        return [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender:function (t,r,index) {
              return parseInt(index)+1;
            }
          },{
            title: this.$t('户型编码'),
            align:"center",
            dataIndex: 'htCode'
          },{
            title: this.$t('户型名称'),
            align:"center",
            dataIndex: 'htName'
          },{
            title: this.$t('日报警量上限'),
            align:"center",
            dataIndex: 'htDayAlarmTop'
          },{
            title: this.$t('日报警下限值'),
            align:"center",
            dataIndex: 'htDayAlarmLow'
          },{
            title: this.$t('创建时间'),
            align:"center",
            dataIndex: 'createTime'
          },{
            title: this.$t('创建人'),
            align:"center",
            dataIndex: 'createBy'
          },
          {
            title: this.$t('操作'),
            dataIndex: 'action',
            align:"center",
            fixed:"right",
            width:147,
            scopedSlots: { customRender: 'action' }
          }
        ]
      },
    },
    methods: {
      initDictConfig(){
      },
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>